<template>
  <div class="text-center p-4 bgb">
    <h3 class="text-center">专业本田原厂中控系统优化</h3>
    <h3 class="text-center">数万车友正在使用</h3>
    <h3 class="text-center">稳定、实用、实惠</h3>
   </div>
</template>

<script>
export default {
  name: "Banner",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {},
  filters: {},
};
</script>
<style scoped>
.bgb {
background-image: url("../assets/racing.jpg");
background-repeat:no-repeat;
background-size:100%;
color: white;
}
</style>
